import React from 'react';
import { Route, Switch } from 'react-router-dom';

import HasCreditChanges from './reapply/HasCreditChanges';
import RerunCredit from './reapply/RerunCredit';

export default function Reapply({ match }) {
  return (
    <Switch>
      <Route path={`${match.path}/rerun_credit`} component={RerunCredit} />
      <Route
        path={`${match.path}/has_credit_changes`}
        component={HasCreditChanges}
      />
    </Switch>
  );
}
